$(function () {
    if($('select[name="role"]').val() == 'global'){
        $('select[name="region"]').parent('div').hide();
    }else{
        $('select[name="region"]').parent('div').show();
    }
    $('select[name="role"]').change(function () {
        if($(this).val() == 'global'){
            $('select[name="region"]').parent('div').hide();
        }else{
            $('select[name="region"]').parent('div').show();
        }
    })
});